<template>
  <table
    class="table table-bordered"
    style="width: 100%;">
    <thead>
      <tr>
        <th style="min-width: 130px;">{{ $t('message.date') }}</th>
        <th class="text-center">{{ $t('message.cashier') }}</th>
        <th class="text-center">{{ $t('apps.pos.message.possession') }}</th>
        <th class="text-center">{{ $t('message.transactions') }}</th>
        <th class="text-center">{{ $t('message.product') }}</th>
        <th
          v-if="getRoleMetadata.view.fields.cost"
          class="text-right"
        >
          {{ $t('message.cost') }}
        </th>
        <th
          v-if="getRoleMetadata.view.fields.discount"
          class="text-right"
        >
          {{ $t('message.discount') }}
        </th>
        <th
          v-if="getRoleMetadata.view.fields.tax"
          class="text-right"
        >
          {{ $t('message.tax') }}
        </th>
        <th
          v-if="getRoleMetadata.view.fields.collect"
          class="text-right"
        >
          {{ $t('message.collect') }}
        </th>
        <th
          v-if="getRoleMetadata.view.fields.refund"
          class="text-right"
        >
          {{ $t('message.refund') }}
        </th>
        <th
          v-if="getRoleMetadata.view.fields.net"
          class="text-right"
        >
          {{ $t('message.net') }}
        </th>
        <th
          v-if="getRoleMetadata.view.fields.profit"
          class="text-right"
        >
          {{ $t('message.profit') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index) in items"
        :key="index"
      >
        <td>
          {{ item.date }}
        </td>
        <td class="text-center">
          {{ getNumber(item.cashiersCount) }}
        </td>
        <td class="text-center">
          {{ getNumber(item.sessionsCount) }}
        </td>
        <td class="text-center">
          {{ getNumber(item.transactionsCount) }}
        </td>
        <td class="text-center">
          {{ getNumber(item.productsCount) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.cost"
          class="text-right"
        >
          {{ getNumber(item.cost) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.discount"
          class="text-right"
        >
          {{ getNumber(item.discount) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.tax"
          class="text-right"
        >
          {{ getNumber(item.tax) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.collect"
          class="text-right"
        >
          {{ getNumber(item.collect) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.refund"
          class="text-right"
        >
          {{ getNumber(item.refund) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.net"
          class="text-right"
        >
          {{ getNumber(item.net) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.profit"
          class="text-right"
        >
          {{ getNumber(item.profit) }}
        </td>
      </tr>
      <tr>
        <td>
          {{ $t('apps.reports.message.total') }}
        </td>
        <td class="text-center">
          {{ getNumber(summary.sessionsCount) }}
        </td>
        <td class="text-center">
          {{ getNumber(summary.cashiersCount) }}
        </td>
        <td class="text-center">
          {{ getNumber(summary.transactionsCount) }}
        </td>
        <td class="text-center">
          {{ getNumber(summary.productsCount) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.cost"
          class="text-right"
        >
          {{ getNumber(summary.cost) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.discount"
          class="text-right"
        >
          {{ getNumber(summary.discount) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.tax"
          class="text-right"
        >
          {{ getNumber(summary.tax) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.collect"
          class="text-right"
        >
          {{ getNumber(summary.collect) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.refund"
          class="text-right"
        >
          {{ getNumber(summary.refund) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.net"
          class="text-right"
        >
          {{ getNumber(summary.net) }}
        </td>
        <td
          v-if="getRoleMetadata.view.fields.profit"
          class="text-right"
        >
          {{ getNumber(summary.profit) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [userPermissionMixin],

  props: ['items'],

  computed: {
    summary () {
      const init = {
        sessionsCount: 0,
        cashiersCount: 0,
        transactionsCount: 0,
        productsCount: 0,
        cost: 0,
        discount: 0,
        tax: 0,
        collect: 0,
        refund: 0,
        net: 0,
        profit: 0,
      }
      return this.items.reduce((acc, cur) => {
        for (const key of Object.keys(init)) {
          acc[key] += cur[key]
        }
        return acc
      }, init)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/combine/ReportSaleTable.vue